import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import thtmglogo from "../assets/thtmglogo.png";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { saffronRout, saffronURL } from "../Url";

const PublicNavbar = () => {
  const location = useLocation();

  const { data, isPending } = useQuery({
    queryKey: ["all_logoes"],
    queryFn: async () => {
      const res = await axios.get(
        "https://thehindutoday.com/api/v1/public/logos",
      );
      return res.data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 60, // 1 hour
    cacheTime: 1000 * 60 * 60 * 6, // 6 hours
  });

  return (
    <header
      className="bg-white shadow-sm sticky top-0 z-[100] h-[110px] md:h-[72px] select-none z-[999]"
      onContextMenu={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onPaste={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1 h-full">
        <div className="flex justify-between items-center py-1 md:h-full">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex flex-col items-start">
              <img
                src={thtmglogo}
                alt="thtmglogo"
                className=" w-[157px] md:w-[177px] mb-[0px]"
              /> </Link>
              
           
          </div>
        
          {(location.pathname === "/" ||
            location.pathname === "/login" ||
            location.pathname === "/register") && (
            <>
              <div className="hidden md:flex items-center gap-2 lg:gap-4">
                {!isPending &&
                  [...(data?.data || [])] // clone array first
                    .reverse()
                    ?.map((img) => (
                      <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-28"
                          }`}
                        />
                      </NavLink>
                    ))}
              </div>
            </>
          )}

          {(location.pathname.includes("/virtual-sevak") ||
            location.pathname.includes(saffronRout) ||
            location.pathname === "/the-hindu-today") && (
            <div className=" hidden sm:block">
              {location.pathname.includes("/virtual-sevak") && (
                !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'virtual-logo')
                    ?.map((img) => (
                      <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-28"
                          }`}
                        />
                      </NavLink>
                    ))
              )}
              {location.pathname.includes(saffronRout) && (
                !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'saffpagesron-logo')
                    ?.map((img) => (
                      <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-32"
                          }`}
                        />
                      </NavLink>
                    ))
              )}
              {location.pathname === "/the-hindu-today1" && (
                !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'thehindutoday-logo')
                    ?.map((img) => (
                      <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-28"
                          }`}
                        />
                      </NavLink>
                    ))
              )}
            </div>
          )}
          {/* Navigation and Action Buttons */}
          {location.pathname === "/" ||
          location.pathname === "/login" ||
          location.pathname === "/register" ? (
            <div className="flex items-center gap-4">
              <Link
                to="/login"
                className="text-sm font-semibold text-gray-600 hover:text-orange-500"
              >
                Login
              </Link>
              <Link
                to="/register"
                className="px-4 py-2 text-sm font-semibold text-white bg-orange-500 rounded-md shadow-sm hover:bg-orange-600"
              >
                Sign Up
              </Link>
            </div>
          ) : (
            <div className="flex items-center gap-4">
              <a
                href={
                  location.pathname.includes(saffronRout)
                    ? `${saffronURL}/en/in-gn/login`
                    : location.pathname === "/the-hindu-today"
                      ? "https://thehindutoday.com/en/uk-gn/login"
                      : location.pathname.includes("/virtual-sevak")
                        ? "https://virtualsevak.com/login"
                        : "#"
                }
                target="_blank"
                rel="noreferrer"
                className="text-sm font-semibold text-gray-600 hover:text-orange-500"
              >
                Login
              </a>
              <a
                href={
                  location.pathname.includes(saffronRout)
                    ? `${saffronURL}/en/in-gn/register`
                    : location.pathname === "/the-hindu-today"
                      ? "https://thehindutoday.com/en/uk-gn/register"
                      : location.pathname.includes("/virtual-sevak")
                        ? "https://virtualsevak.com/register"
                        : "#"
                }
                target="_blank"
                rel="noreferrer"
                className="px-4 py-2 text-sm font-semibold text-white bg-orange-500 rounded-md shadow-sm hover:bg-orange-600"
              >
                Sign Up
              </a>
            </div>
          )}
        </div>

          <div className=" block sm:hidden">
            

                {location.pathname.includes("/virtual-sevak") && (
                  !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'virtual-logo')
                    ?.map((img) => (
                      <>
                      <hr className="my-2 md:hidden" />
                        <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-28"
                          }`}
                        />
                      </NavLink>
                      </>
                    
                    ))
                )}
                {location.pathname.includes(saffronRout) && (
                  !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'saffpagesron-logo')
                    ?.map((img) => (
                      <>
                      <hr className="my-2 md:hidden" />
                       <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-32"
                          }`}
                        />
                      </NavLink>
                      </>
                     
                    ))
                )}
                {location.pathname === "/the-hindu-today" && (
                  !isPending &&
                  [...(data?.data || [])] // clone array first
                    .filter(item => item?.name === 'thehindutoday-logo')
                    ?.map((img) => (
                      <>
                      <hr className="my-2 md:hidden" />
                      <NavLink
                        to={img?.link}
                        target="_blank"
                        key={img?.id || img?.name}
                      >
                        <img
                          src={img?.image || "https://via.placeholder.com/100"}
                          alt={img?.alt || "logo"}
                          className={`object-contain rounded-md ${
                            img?.name === "thehindutoday-logo" ||
                            img?.name === "virtual-logo"
                              ? "w-20 lg:w-[90px]"
                              : "w-20 lg:w-28"
                          }`}
                        />
                      </NavLink>
                      </>
                      
                    ))
                )}
              </div>

        {(location.pathname === "/" ||
          location.pathname === "/login" ||
          location.pathname === "/register") && (
          <>
            <hr className="my-2 md:hidden" />
            <div className=" flex justify-center items-center md:hidden gap-2 ">
              {[...(data?.data || [])] // clone array first
                .reverse()
                ?.map((img, index) => (
                  <NavLink to={img?.link} target="_blank" key={index}>
                    <img
                      src={img?.image || "https://via.placeholder.com/100"}
                      alt={img?.alt}
                      className={` object-contain rounded-md ${img?.name === "thehindutoday-logo" || img?.name === "virtual-logo" ? `w-[70px] ` : `w-20 `}`}
                    />
                  </NavLink>
                ))}
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default PublicNavbar;
